let _keydownHandler = null;

let _lastKeyboardEventTime = 0;
const KEYBOARD_THROTTLE = 200;

export const keyboardState = {};

export const keyboardGetters = {};

export const keyboardMutations = {};

export const keyboardActions = {
  startKeyboardProctoring({ dispatch }) {
    if (_keydownHandler) return;

    _keydownHandler = (e) => {
      const isCmdOrCtrl = e.ctrlKey || e.metaKey;

      // ── Step 1: Determine if this key combo is blocked ──────────────────
      let isBlocked = false;
      let violationReason = null;
      let isLog = false;

      // Copy, Paste, Cut
      if (isCmdOrCtrl && ["c", "C", "v", "V", "x", "X"].includes(e.key)) {
        const action =
          e.key.toLowerCase() === "c"
            ? "Copy"
            : e.key.toLowerCase() === "v"
            ? "Paste"
            : "Cut";
        violationReason = `${action} Attempt detected`;
        isBlocked = true;
      }

      // Tab Switching
      if (e.key === "Tab" && (isCmdOrCtrl || e.shiftKey || e.altKey)) {
        violationReason = "Tab switching shortcut detected";
        isBlocked = true;
      }

      // Print — Ctrl+P
      if (isCmdOrCtrl && (e.key === "p" || e.key === "P")) {
        violationReason = "Print attempt detected";
        isLog = true;
        isBlocked = true;
      }

      // Screenshot
      if (e.key === "PrintScreen") {
        violationReason = "Screenshot attempt detected";
        isBlocked = true;
      }

      // DevTools — Ctrl+Shift+I, Ctrl+Shift+J, F12
      const isDevTools =
        e.key === "F12" ||
        (isCmdOrCtrl &&
          e.shiftKey &&
          (e.key === "I" || e.key === "i" || e.key === "J" || e.key === "j"));
      if (isDevTools) {
        violationReason = "Developer tools access attempt";
        isLog = true;
        isBlocked = true;
      }

      // View Source — Ctrl+U
      if (isCmdOrCtrl && (e.key === "u" || e.key === "U")) {
        violationReason = "View source attempt detected";
        isLog = true;
        isBlocked = true;
      }

      // Page Reload — F5, Ctrl+R
      if (e.key === "F5" || (isCmdOrCtrl && (e.key === "r" || e.key === "R"))) {
        violationReason = "Page reload attempt detected";
        isLog = true;
        isBlocked = true;
      }

      if (isBlocked) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }

      const now = Date.now();
      if (isBlocked && now - _lastKeyboardEventTime >= KEYBOARD_THROTTLE) {
        _lastKeyboardEventTime = now;
        dispatch(
          "triggerViolation",
          isLog ? { reason: violationReason, isLog } : violationReason
        );
      }
    };

    window.addEventListener("keydown", _keydownHandler, true);
  },

  stopKeyboardProctoring() {
    if (_keydownHandler) {
      window.removeEventListener("keydown", _keydownHandler, true);
      _keydownHandler = null;
    }
  },
};
